import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './sign-up.magic.css.js';
import script from './sign-up.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"part":"wrapper","data-v-test-id":"signup-v2-wrapper"}},[(_vm.showRegistrationForm)?_c('magic-form-builder',{attrs:{"current-step":_vm.currentStep},domProps:{"config":_vm.formConfig,"initialState":_vm.formModel,"submitState":_vm.submitState,"updatedField":_vm.updateField},on:{"form-change":_vm.onChange,"form-submit":_vm.onSubmit,"next-step":_vm.nextStep}}):(_vm.currentStep === _vm.verificationPromptStep)?_c('magic-corex-verify-prompt',{staticClass:"sign-up step step--3",attrs:{"keep-alive":"","part":"sign-up step step--3","data-v-test-id":"step3-verify-prompt","steps":_vm.verificationPromptStep},on:{"verification-error":function($event){return _vm.signupError($event.detail[0])}}}):(_vm.currentStep === 'verification' && _vm.verificationCode && _vm.userId)?_c('magic-corex-verify-email',{attrs:{"data-v-test-id":"step3-verify-prompt","verification-code":_vm.verificationCode,"user-id":_vm.userId},on:{"verification-error":function($event){return _vm.signupError($event.detail[0])},"verified":function($event){return _vm.registerConfirmed($event.detail[0])}}}):_vm._e(),_vm._v(" "),_vm._t("form-footer",null,{"dataVTestId":"step3-form-footer"})],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-7b814c66_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-7b814c66";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
